import { Component, Input, OnInit } from '@angular/core';
import { Post } from '@interfaces/api.post.interface';

@Component({
  selector: 'ark-ui-og',
  templateUrl: './ui-og.component.html',
  styleUrls: ['./ui-og.component.scss'],
})
export class UiOgComponent implements OnInit {
  @Input() post?: Post;
  constructor() {}

  ngOnInit() {}
}
